import { render } from "./CorporatePlanOpportunitiesComponent.vue?vue&type=template&id=5c5f7e6d"
import script from "./CorporatePlanOpportunitiesComponent.vue?vue&type=script&lang=js"
export * from "./CorporatePlanOpportunitiesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__